import createClient, { Middleware } from 'openapi-fetch';
import createQueryClient from "openapi-react-query";
import { paths } from '@next-is-free-monorepo/api-types';
import { apiUrl } from './urls';
import { supabase } from './supabase';


export const apiClient = createClient<paths>({ baseUrl: apiUrl + '/v1' });

apiClient.use({
  onRequest: async ({ request }) => {
    const url = new URL(request.url);

    if (url.pathname.startsWith("/public")) {
      return request;
    }

    const { data } = await supabase.auth.getSession();
    const token = data.session?.access_token;
    if (token) {
      request.headers.set("Authorization", `Bearer ${token}`);
    }

    return request;
  }
});

export const $api = createQueryClient(apiClient);
